import React from "react";
import { useLang } from "../context/LanguageContext";

const PrivacyPage = () => {
  const { lang } = useLang();
  const content = lang === "hi" ? hi : en;
  return (
    <div data-testid="privacy-page" className="max-w-3xl mx-auto px-4 lg:px-8 py-12 lg:py-16">
      <div className="text-xs uppercase tracking-[0.14em] text-teal-700 font-semibold">{lang === "hi" ? "गोपनीयता नीति" : "Privacy Policy"}</div>
      <h1 className="mt-2 text-3xl sm:text-4xl font-heading font-semibold text-slate-900">{content.title}</h1>
      <div className="mt-6 prose prose-slate max-w-none space-y-4 text-slate-700 leading-relaxed">
        {content.sections.map((s, i) => (
          <section key={i}>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mt-6">{s.h}</h2>
            <p>{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
};

const en = {
  title: "How we protect your information",
  sections: [
    { h: "What we collect", p: "When you submit a request, we collect the details you provide — name, mobile number, address, optional email, chosen service, notes, and the documents you upload." },
    { h: "How we store it", p: "Your documents are stored on private secure cloud storage. Only authorised Ashish Point staff (branch operators) can access them for the purpose of completing your application." },
    { h: "Who can see it", p: "We do not sell or share your personal information with third parties. Documents are shared only with the concerned government portal necessary to file your application." },
    { h: "How long we keep it", p: "We retain your data for the time required to complete the service and for legal/compliance record-keeping. You may request deletion by contacting our branch directly." },
    { h: "Contact us", p: "For any privacy questions, WhatsApp us at +91 70703 35050 or visit either of our Bihar branches (Miratola / Dighwa Dubauli)." },
  ],
};

const hi = {
  title: "आपकी जानकारी हम कैसे सुरक्षित रखते हैं",
  sections: [
    { h: "हम क्या जानकारी लेते हैं", p: "जब आप आवेदन जमा करते हैं, तब हम आपके द्वारा दी गई जानकारी लेते हैं — नाम, मोबाइल, पता, ईमेल (यदि दिया हो), चयनित सेवा, नोट्स तथा अपलोड किए गए दस्तावेज़।" },
    { h: "जानकारी कहाँ रखी जाती है", p: "आपके दस्तावेज़ निजी सुरक्षित क्लाउड स्टोरेज पर रखे जाते हैं। केवल अधिकृत आशीष पॉइंट कर्मी (शाखा संचालक) ही आवेदन पूरा करने के लिए इन्हें देख सकते हैं।" },
    { h: "कौन देख सकता है", p: "हम आपकी निजी जानकारी किसी तीसरे पक्ष को नहीं बेचते व साझा नहीं करते। दस्तावेज़ केवल संबंधित सरकारी पोर्टल पर आवेदन दाखिल करने हेतु ही उपयोग होते हैं।" },
    { h: "कब तक रखी जाती है", p: "जब तक सेवा पूर्ण न हो जाए और वैधानिक रिकॉर्ड आवश्यकता के अनुसार जानकारी रखी जाती है। हटाने का अनुरोध आप शाखा से सीधे कर सकते हैं।" },
    { h: "संपर्क", p: "किसी भी प्रश्न हेतु व्हाट्सएप करें +91 70703 35050 या अपनी नज़दीकी शाखा (मिरतोला / डिघवा दुबौली) पर पधारें।" },
  ],
};

export default PrivacyPage;
